import { NumberFieldUI } from '@axo/form/feature/form-input/NumberField/NumberFieldUI';
import type { IFieldOptions } from '@axo/form/feature/form-input/types';
import { useTranslation } from '@axo/shared/i18n';
import { useMemo } from 'react';
import { useBroker } from '../../../../../hooks/useBroker';
import { Currency } from '../../../../../utils/Currency.format';
import { formatSpacedNumber } from '../../../../../utils/format';
import type { EmploymentFormGroupData } from '../../FormData.se.types';
import { grossIncomeMonthlyMinimum } from '../../config/globals';

export const GrossIncomeMonthlyField = ({
  applicant = '',
}: {
  applicant?: '' | 'CoApplicant';
}) => {
  const { t } = useTranslation();

  const broker = useBroker();

  const grossIncomeMonthlyFieldOptions = useMemo(() => {
    return {
      registerOptions: {
        required: 'GrossIncomeMonthly.error.required',
        min: {
          value: grossIncomeMonthlyMinimum[broker],
          message: t('GrossIncomeMonthly.error.amount', {
            amount: Currency.format(grossIncomeMonthlyMinimum[broker]),
          }),
        },
      },
      warningValidation: {
        message: (value) => {
          if (value > 100_000) {
            return 'GrossIncomeMonthly.error.soft.amount';
          }
        },
      },
    } satisfies IFieldOptions;
  }, [broker, t]);

  return (
    <NumberFieldUI<EmploymentFormGroupData>
      name={`Frontend/${applicant}GrossIncomeMonthly`}
      label={t('GrossIncomeMonthly.label')}
      data-testid="income-input"
      suffix={t('suffix.currency')}
      format={formatSpacedNumber}
      {...grossIncomeMonthlyFieldOptions}
    />
  );
};
